module.exports = __webpack_public_path__ + "media/images/no-img-available-7b5142ebdf559eab000942ab1880a4f6.png";